/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Task_Requested_Documents_RemoveInputs */

const en_task_requested_documents_remove = /** @type {(inputs: Task_Requested_Documents_RemoveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Remove requested document`)
};

const pt_br2_task_requested_documents_remove = /** @type {(inputs: Task_Requested_Documents_RemoveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Remover documento solicitado`)
};

/**
* | output |
* | --- |
* | "Remove requested document" |
*
* @param {Task_Requested_Documents_RemoveInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const task_requested_documents_remove = /** @type {((inputs?: Task_Requested_Documents_RemoveInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Task_Requested_Documents_RemoveInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_task_requested_documents_remove(inputs)
	return pt_br2_task_requested_documents_remove(inputs)
});